import React, {FunctionComponent, useContext} from 'react';
import "./RejectedSignaturePage.scss"
import {InvoiceContext} from "../../context/InvoiceContext";
import rejectIcon from "../../assets/icons/ban-duotone.svg";

export const RejectedSignaturePage: FunctionComponent = () => {
    const invoice = useContext(InvoiceContext);

    return (
        <div className='full-page-section'>
            <img src={rejectIcon} alt="reject" className="full-page-icon"/>
            <h1>{invoice.invoice_title} has been rejected.</h1>
        </div>
    );
};